import React from 'react';
import { Menu, Dropdown } from 'antd';

const MenuC = (
  <Menu>
    <Menu.Item>
      <a target="_blank" rel="noopener noreferrer" href="http://www.alipay.com/">
        1st menu item
      </a>
    </Menu.Item>
    <Menu.Item>
      <a target="_blank" rel="noopener noreferrer" href="http://www.taobao.com/">
        2nd menu item
      </a>
    </Menu.Item>
    <Menu.Item>
      <a target="_blank" rel="noopener noreferrer" href="http://www.tmall.com/">
        3rd menu item
      </a>
    </Menu.Item>
  </Menu>
);

export const ActionMenu = () => {
  return (
    <Dropdown overlay={MenuC} placement="bottomLeft">
      <button>s</button>
    </Dropdown>
  );
}